// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3-gW_","close":"styles_close__2eRHZ","btn-cancel":"styles_btn-cancel__zXiJF","for_approval_table":"styles_for_approval_table__3BEuz"};